/**
 * Site-wide notice shown only while login is disabled (REACT_APP_LOGIN_ENABLED is not "true"), so visitors who
 * are sent home from sign-in or demo links know why. Fixed to the bottom of the screen: the navbar is
 * fixed at the top and page layouts assume its height, so a top banner would cover headings on phones.
 * The body gets matching bottom padding so the banner never hides the end of a page.
 */
import React, { useEffect } from "react";
import { LOGIN_ENABLED } from "../../loginAvailability";
import { LOGIN_MAINTENANCE_BANNER } from "../../../constants/platformCopy";
import "./MaintenanceBanner.css";

const BODY_CLASS_WHILE_SHOWN = "has-maintenance-banner";

const MaintenanceBanner: React.FC = () => {
  useEffect(() => {
    if (LOGIN_ENABLED) {
      return undefined;
    }
    document.body.classList.add(BODY_CLASS_WHILE_SHOWN);
    return () => document.body.classList.remove(BODY_CLASS_WHILE_SHOWN);
  }, []);

  if (LOGIN_ENABLED) {
    return null;
  }
  return (
    <div className="maintenance-banner" role="status">
      {LOGIN_MAINTENANCE_BANNER}
    </div>
  );
};

export default MaintenanceBanner;
